var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3976_9216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.05 4.9375C17.2375 3.125 14.75 2 11.9875 2C6.4625 2 2 6.475 2 12C2 17.525 6.4625 22 11.9875 22C16.65 22 20.5375 18.8125 21.65 14.5H19.05C18.025 17.4125 15.25 19.5 11.9875 19.5C7.85 19.5 4.4875 16.1375 4.4875 12C4.4875 7.8625 7.85 4.5 11.9875 4.5C14.0625 4.5 15.9125 5.3625 17.2625 6.725L13.2375 10.75H21.9875V2L19.05 4.9375Z",
    fill: "#4E5968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3976_9216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.3e13a736129ac69ff86afa78f3278eee.svg";
export { ForwardRef as ReactComponent };